import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { node, oneOf } from 'prop-types';
import styled from 'styled-components';
import { TEXT_SIZES } from './constants.js';
export { TEXT_SIZES } from './constants.js';

var _templateObject;

/**
 * For the sake of clarity and consistency with the theme naming
 * conventions, the 'MEDIUM' variant should be renamed to 'STANDARD'.
 * As a fail-safe, a default case can be set so it defaults to
 * the standard value.
 */
const Text = /*#__PURE__*/styled.p.withConfig({
  displayName: "text__Text",
  componentId: "sc-2i3h0c-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: 0;\n  line-height: ", ";\n\n  [dir='rtl'] & {\n    line-height: ", ";\n  }\n\n  font-size: ", ";\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.lineHeights.body;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.rtlLineHeights.body;
}, _ref3 => {
  let {
    size,
    theme: {
      fontSizes
    }
  } = _ref3;
  switch (size) {
    case TEXT_SIZES.SMALL:
      {
        return fontSizes.small;
      }
    case TEXT_SIZES.MEDIUM:
      {
        return fontSizes.standard;
      }
    case TEXT_SIZES.LARGE:
      {
        return fontSizes.large;
      }
    case TEXT_SIZES.XLARGE:
      {
        return fontSizes.xlarge;
      }
    case TEXT_SIZES.XXLARGE:
      {
        return fontSizes.xxlarge;
      }
    // no default
  }
});

const TextProps = {
  children: node.isRequired,
  size: oneOf(Object.values(TEXT_SIZES))
};
Text.propTypes = TextProps;
Text.defaultProps = {
  size: TEXT_SIZES.MEDIUM
};

export { Text };
